import { z } from 'zod'

export const commonResponseSchema = z.object({
  retCode: z.number().int(),
  retMsg: z.string(),
  retExtInfo: z.unknown(),
  time: z.number().int().optional(),
})

export const successReponseSchema = commonResponseSchema.extend({
  retCode: z.literal(0),
  retMsg: z.union([
    z.literal('Success'),
    z.literal('success'),
    z.literal('OK'),
    z.literal(''),
  ]),
})
